import React from "react";
import { Header, Footer, ReferenceLogos } from "../containers";
import {MetaTags, } from '../components'

const Layout = ({ children ,title}) => {
  return (
    <>
    <MetaTags title={title}/>
      <Header isTransparent={false}/>
      {children}
      <br />
      <br />
      <br />
      <br />
      <br />
    
      <ReferenceLogos />
      <Footer />
      
    </>
  );
};



export default Layout;
